import { Component } from 'react';
import { AlertTriangle, RotateCcw } from 'lucide-react';

/**
 * Catches render-time JS errors that would otherwise leave a blank white
 * screen (Alian's video: "convertir a trabajo... la aplicacion se queda en
 * blanco, nada, solo se recupera con refresh"). Shows a friendly message
 * with a retry button instead. Keyed by the current route in Layout.jsx so
 * navigating away automatically clears the error.
 */
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div data-testid="error-boundary-fallback" className="flex flex-col items-center justify-center py-24 px-4 text-center">
          <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <AlertTriangle className="w-7 h-7 text-red-500" />
          </div>
          <h2 className="text-lg font-semibold text-gray-800 mb-1">No se pudo abrir esta pantalla</h2>
          <p className="text-sm text-gray-500 mb-5 max-w-sm">
            Ocurrio un error inesperado. Intenta de nuevo; si el problema sigue, avisale al equipo tecnico.
          </p>
          <button
            type="button"
            data-testid="error-boundary-retry-btn"
            onClick={() => this.setState({ hasError: false })}
            className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#003366] text-white text-sm font-medium hover:bg-[#004080] transition-colors"
          >
            <RotateCcw className="w-4 h-4" /> Intentar de nuevo
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
